angular.module('webtrader').component('marketReview', {
  bindings: {
    classes: '=',
  },
  templateUrl: (Account) => {
    if(Account.info.group.is_options)
      return BASE_URL+'templates/component.marketReviewOptions.html'
    return BASE_URL+'templates/component.marketReview.html'
  },
  controller: function (Account, Quotes) {
    this.quotes = Quotes
  }
})
